module.exports = __webpack_public_path__ + "img/fibraConcreto1.6984c2d6.png";